import React, { useEffect, useState } from 'react';
import api from '../api';
import { Helmet } from 'react-helmet';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  const [pages, setPages] = useState({ about: '', contact: '', location: '' });
  const [services, setServices] = useState([]);
  const [internships, setInternships] = useState([]);

  useEffect(() => {
    fetchContent();
    fetchServices();
    fetchInternships();
  }, []);

  const fetchContent = async () => {
    try {
      const about = await api.get('/pages/about');
      const contact = await api.get('/pages/contact');
      const location = await api.get('/pages/location');
      setPages({
        about: about.data.content || '',
        contact: contact.data.content || '',
        location: location.data.content || ''
      });
    } catch (err) {
      console.error('Error loading content', err);
    }
  };

  const fetchServices = async () => {
    try {
      const res = await api.get('/services');
      setServices(res.data);
    } catch (err) {
      console.error('Error loading services', err);
    }
  };

  const fetchInternships = async () => {
    try {
      const res = await api.get('/internships');
      setInternships(res.data);
    } catch (err) {
      console.error('Error loading internships', err);
    }
  };

  return (
    <>
      <Helmet>
        <title>InfoKshetra - Empowering Digital Solutions</title>
        <meta name="description" content="Professional software solutions, web development, and internship programs by InfoKshetra Pvt Ltd in Bidar." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="InfoKshetra - Empowering Digital Solutions" />
        <meta property="og:description" content="Explore our services, internships, and digital solutions." />
        <meta property="og:image" content="/logo1.jpg" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="InfoKshetra - Empowering Digital Solutions" />
        <meta name="twitter:description" content="Web development, internships, software, and IT solutions from Bidar." />
        <meta name="twitter:image" content="/logo1.jpg" />
      </Helmet>

      {/* Navbar with Logo */}
      <Navbar expand="lg" bg="dark" variant="dark" sticky="top" collapseOnSelect>
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img
              src="/logo1.jpg"
              alt="Logo"
              height="40"
              className="me-2"
              style={{ borderRadius: '4px' }}
            />
            <span className="fw-bold text-white">InfoKshetra</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto">
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#services">Services</Nav.Link>
              <Nav.Link href="#internships">Internships</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
              <Nav.Link as={Link} to="/admin">Admin</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <section className="text-white text-center d-flex align-items-center"
        style={{ minHeight: '90vh', background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)' }}>
        <div className="container">
          <h1 className="display-4 fw-bold">Welcome to InfoKshetra</h1>
          <p className="lead mt-3">Empowering Digital Solutions & Real-world Learning</p>
          <a href="#about" className="btn btn-outline-light mt-4 px-4 py-2 fw-semibold">Explore More</a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-5" style={{ backgroundColor: '#002B5B', color: 'white' }}>
        <div className="container">
          <h2 className="text-center mb-4">🧭 About Us</h2>
          <div className="lead" dangerouslySetInnerHTML={{ __html: pages.about || 'Loading about content...' }} />
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-5" style={{ backgroundColor: '#F0F0F0' }}>
        <div className="container">
          <h2 className="text-center mb-4">💼 Our Services</h2>
          <div className="row">
            {services.map((s, i) => (
              <div className="col-md-4 mb-4" key={i}>
                <div className="card h-100 shadow-sm">
                  {s.image && <img src={s.image} className="card-img-top" alt={s.title} />}
                  <div className="card-body">
                    <h5>{s.title}</h5>
                    <p>{s.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Internships Section */}
      <section id="internships" className="py-5" style={{ backgroundColor: '#E9F7EF' }}>
        <div className="container">
          <h2 className="text-center mb-4">🎓 Internship Programs</h2>
          <div className="row">
            {internships.map((item, idx) => (
              <div className="col-md-6 mb-3" key={idx}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-text">{item.description}</p>
                    <a href={`/apply/${item.id}`} className="btn btn-outline-primary mt-3">Apply Now</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5" style={{ backgroundColor: '#1B1A55', color: 'white' }}>
        <div className="container">
          <h2 className="text-center mb-4">📍 Contact Us</h2>
          <div className="lead" dangerouslySetInnerHTML={{ __html: pages.contact || 'Loading contact content...' }} />
        </div>
      </section>

      {/* Location Section */}
      <section id="location" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">📌 Location</h2>
          <div className="text-center mb-3">
            <div dangerouslySetInnerHTML={{ __html: pages.location || '<p class="text-muted">Loading location...</p>' }} />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-white text-center py-4 mt-5"
        style={{ background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)' }}>
        <div className="container">
          <p className="mb-1">📞 94925 12246 | 98861 82081</p>
          <p className="mb-0">&copy; {new Date().getFullYear()} InfoKshetra Pvt Ltd. All rights reserved.</p>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="btn btn-primary position-fixed"
        style={{ bottom: '20px', right: '20px', zIndex: 999 }}
      >
        ↑ Top
      </button>
    </>
  );
}
